import Styled from 'styled-components';
import { Button } from '../buttons';

const ActionsButton = Styled(Button)`
  background: ${(props) => props.primaryColor};
  color: ${(props) => props.textColor};
  box-shadow: none;
  padding: 0px 0px;
  height: ${props => props.height ? props.height : '25px'};
  width: ${props => props.width ? props.width : '25px'} ;
  min-width: 25px;
  min-height: 25px;
  white-space: normal;
  word-break: break-word;
  text-align: center;
  svg {
    width: 17px;
  }
`;

export { ActionsButton }